import { UserItem } from "shared/api";
import { AdaptedValues } from "shared/types";

export const getUserDisplayName = (user: UserItem) =>
  `${user?.first_name ?? ""} ${user?.last_name ?? ""}`.trim() || user?.username;

export const adaptUsersToOptions = (users: UserItem[]): AdaptedValues[] =>
  users
    ?.filter((user) => user?.id != null)
    .map((user) => ({
      label: getUserDisplayName(user),
      value: user?.id!,
    })) || [];
